import { Button, Card, Input, Space, Table } from "antd";
import { useFetchUsersQuery } from "./accounts.service";
import { useRef, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import "./style.css";

const { Column } = Table;

const AccountsPage = () => {
  const {
    data = {
      data: {
        users: [],
      },
    },
    isSuccess,
  } = useFetchUsersQuery("", { refetchOnMountOrArgChange: true });

  const {
    data: { users },
  } = data;

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => {
            var _a;
            return (_a = searchInput.current) === null || _a === void 0
              ? void 0
              : _a.select();
          }, 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  return (
    <Card title="Account List" style={{ fontSize: "20px" }} bordered={false}>
      <Table
        dataSource={users.reduce((arr, cur) => {
          arr.push({
            ...cur,
            createdAt: new Date(cur.createdAt)
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
            restaurantName: cur.restaurantId?.name || "",
          });
          return arr;
        }, [])}
        pagination={true}
        rowKey="key"
      >
        <Column
          title="#"
          dataIndex={"key"}
          render={(text, record, index) => index + 1}
        />
        <Column
          title="Email"
          dataIndex={"email"}
          {...getColumnSearchProps("email")}
        />
        <Column
          title="Business Name"
          dataIndex={"restaurantName"}
          {...getColumnSearchProps("restaurantName")}
        />
        <Column
          title="Subscription Status"
          dataIndex={"subscriptionStatus"}
          {...getColumnSearchProps("subscriptionStatus")}
        />
        <Column
          title="createdAt"
          dataIndex={"createdAt"}
          {...getColumnSearchProps("createdAt")}
        />
      </Table>
    </Card>
  );
};

export default AccountsPage;
